import { breadcrumb } from './breadcrumb';

export const hlr = {
  breadcrumb,

  requests: {
    index: 'Request',
    create_request: 'Create request',

    status: {
      pending: 'Pending',
      processing: 'Processing',
      rejected: 'Rejected',
      failed: 'Failed',
      success: 'Success'
    },
    download: {
      tooltip: 'Export'
    },
    upload: {
      success: 'Request successfully created'
    }
  }
};
